import { CacheLocation } from '../core';
export const getBrowserStorage = (cacheLocation) => {
    return cacheLocation === CacheLocation.LocalStorage ? window.localStorage : window.sessionStorage;
};
//# sourceMappingURL=getBrowserStorage.js.map